var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineIconFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555555",
    d: "M92.6,81.4h-6.5c-.6-2.1-2.2-3.7-4.3-4.3v-10h6.9c.9,0,1.7-.8,1.7-1.7v-10.3c0-.9-.8-1.7-1.7-1.7h-17.1c-.9,0-1.7.8-1.7,1.7v10.3c0,.9.8,1.7,1.7,1.7h6.9v10c-2.1.6-3.7,2.2-4.3,4.3h-7.9c-.6-2.1-2.2-3.7-4.3-4.3v-32.8h6.9c.9,0,1.7-.8,1.7-1.7v-10.3c0-.9-.8-1.7-1.7-1.7h-17.1c-.9,0-1.7.8-1.7,1.7v10.3c0,.9.8,1.7,1.7,1.7h6.9v32.8c-2.1.6-3.7,2.2-4.3,4.3h-7.3c-.6-2.1-2.2-3.7-4.3-4.3v-10h6.9c.9,0,1.7-.8,1.7-1.7v-10.3c0-.9-.8-1.7-1.7-1.7h-17.1c-.9,0-1.7.8-1.7,1.7v10.3c0,.9.8,1.7,1.7,1.7h6.9v10c-2.1.6-3.7,2.2-4.3,4.3h-7.1c-.9,0-1.7.8-1.7,1.7s.8,1.7,1.7,1.7h7.1c.8,2.6,3.2,4.6,6,4.6s5.3-1.9,6-4.6h7.3c.8,2.6,3.2,4.6,6,4.6s5.3-1.9,6-4.6h7.9c.8,2.6,3.2,4.6,6,4.6s5.3-1.9,6-4.6h6.5c.9,0,1.7-.8,1.7-1.7s-.8-1.7-1.7-1.7ZM40.6,86c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9,2.9,1.3,2.9,2.9-1.3,2.9-2.9,2.9ZM60,86c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9,2.9,1.3,2.9,2.9-1.3,2.9-2.9,2.9ZM80,86c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9,2.9,1.3,2.9,2.9-1.3,2.9-2.9,2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIconFlat);
export default __webpack_public_path__ + "static/media/timeline-icon-flat.acf2d6206be5a9b1e947fc396178a63f.svg";
export { ForwardRef as ReactComponent };